import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { logOutAll } from 'Redux/ducks/auth';

const messages = defineMessages({
  warning: {
    id: 'logoutall.warning',
    defaultMessage: 'You will be logged out of all devices, including this one.',
  },
});

const LogOutAll = ({ doLogOutAll, intl }) => {
  const { formatMessage } = intl;

  const handleClick = () => {
    if (window.confirm(formatMessage(messages.warning))) { // eslint-disable-line no-alert
      doLogOutAll();
    }
  };

  return (
    <div className="account-table-row">
      <div className="account-table-row-title">
        <FormattedMessage
          id="logoutall.title"
          defaultMessage="Secure your account"
        />
      </div>
      <div className="account-table-row-content">
        <div className="account-table-details-container">
          <FormattedMessage
            id="logoutall.description"
            defaultMessage="If you believe that your account has been compromised you can sign out of all devices here. You will have to sign in again."
          />
        </div>
        <div className="account-table-action-container">
          <button type="button" className="account-table-action-button" onClick={() => handleClick()}>
            <FormattedMessage id="logoutall.button" defaultMessage="Sign out of all devices" />
          </button>
        </div>
      </div>
    </div>
  );
};

LogOutAll.propTypes = {
  doLogOutAll: PropTypes.func.isRequired,
};

export default connect(null, { doLogOutAll: logOutAll })(injectIntl(LogOutAll));
